import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { InputDialogData, InputDialogReturnData } from './input.dialog.component';
import { JoiAccount } from 'globals/store/accounts.data';
import { Wrapper } from '../wrapper.component';
import { InputDialogBodyComponent } from './input.dialog.body.component';
import { AccountSelectorComponent } from './account-selector.component';

@Component({
    selector: 'new-event-list-dialog',
    template: `
<input-dialog-body
  [data]="newEventListDialogData"
  [dialogRef]="fakeDialogRef"  
  >
  <div class="belowInput">
    <account-selector
      [title]="'SELECT ACCOUNT'"
      [contributorOK]="false"
      (initialAutoSelection)="setAccount($event)" 
      (dropdownSelection)="setAccount($event)" 
    ></account-selector>
    <div class="under-message">Event lists can only contain events from one account.</div>
  </div>
</input-dialog-body>
  `,
    styles: [`
.under-message { color: rgba(0, 0, 0, 0.4); font-style: italic; }
  `],
    standalone: true,
    imports: [InputDialogBodyComponent, AccountSelectorComponent,]
})
export class NewEventListDialogComponent extends Wrapper<NewEventListDialogComponent> {
  newEventListDialogData: InputDialogData = this.getNewEventListDialogData()
  fakeDialogRef = { close: this.close.bind(this) }
  selectedAccount: JoiAccount

  constructor(private dialogRef: MatDialogRef<NewEventListDialogComponent>) { 
    super()
  }

  setAccount(account: JoiAccount) {
    this.selectedAccount = account
  }

  close(fakeReturnData: InputDialogReturnData) {
    if (!fakeReturnData) return this.dialogRef.close(null)
    const [ name, description ] = fakeReturnData.values
    const returnData: NewEventListDialogReturnData = { name, description, account: this.selectedAccount }
    this.dialogRef.close(returnData)
  }

  getNewEventListDialogData(): InputDialogData {
    return {
      title: 'New event list',
      placeholder: 'Event list name',
      header: 'Give your new event list a name and description',
      successLabel: 'CREATE',
      currentValue: '',
      emptyOK: false,
      secondValue: '',
      secondPlaceholder: 'Event list description',
      backgroundColor: this.uiService.labelsByType.event.color,
    }
  }

}

export interface NewEventListDialogReturnData {
  account: JoiAccount
  name: string
  description: string
}